import { render, staticRenderFns } from "./UiAccordionItem.vue?vue&type=template&id=c742bd2c&"
import script from "./UiAccordionItem.vue?vue&type=script&lang=js&"
export * from "./UiAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./UiAccordionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports